import { MathUtils } from '@jumpstart/core';
import { CanvasObject } from './CanvasObject';
import { Controller } from './Controller';
import { IBlock } from './temp';

const tolerance = 5;

export interface ILink {
  from: string;
  to?: string;
  text: string;
}

export class Link extends CanvasObject<ILink> {

  private color = '#ffc';
  private selectedColor = '#ccffda';
  private path: Path2D;

  constructor(private start: CanvasObject<IBlock>, private end: CanvasObject<IBlock>, public meta: ILink) {
    super(0, 0, meta);
    this.path = new Path2D();
  }

  public update(controller: Controller, canvas: HTMLCanvasElement, c: CanvasRenderingContext2D): void {
    c.beginPath();
    c.lineWidth = 5;
    c.shadowBlur = 10;
    c.moveTo(this.start.x, this.start.y);
    c.lineTo(this.end.x, this.end.y);


    // cp1 and cp2 should be half way either on dominant axis
    // const distance = {
    //   x: Math.abs(this.start.x - this.end.x),
    //   y: Math.abs(this.start.y - this.end.y)
    // };
    // if (distance.x > distance.y) {
    //   // halfway point on x-axis
    // } else {
    //   // halfway point on y-axis
    // }
    //
    // let cp1 =   { x: this.end.x / 2,   y: this.end.y  };
    // let cp2 =   { x: this.start.x / 2,   y: this.start.y  };
    // // c.bezierCurveTo(20, 100, 200, 100, 200, 20);
    // c.bezierCurveTo(cp1.x, cp1.y, cp2.x, cp2.y, this.end.x, this.end.y);
    c.strokeStyle = controller.link && controller.link.meta.id === this.meta.from ? this.selectedColor : this.color;
    if (typeof controller.click.x === 'number' && typeof controller.click.y === 'number') {
      // get n=3 points
      const x0 = ((2/3) * this.start.x) + ((1/3) * this.end.x);
      const y0 = ((2/3) * this.start.y) + ((1/3) * this.end.y);
      const x1 = ((1/3) * this.start.x) + ((2/3) * this.end.x);
      const y1 = ((1/3) * this.start.y) + ((2/3) * this.end.y);
      // c.beginPath();
      // c.fillStyle = '#2d03c4';
      // c.arc(x0, y0, 10, 0, 2 * Math.PI);
      // c.arc(x1, y1, 10, 0, 2 * Math.PI);
      // c.fill();
      var linepoint = this.linepointNearestMouse({x0: x0, y0: y0, x1: x1, y1: y1}, controller.click.x, controller.click.y);
      var dx = controller.click.x - linepoint.x;
      var dy = controller.click.y - linepoint.y;
      var distance = Math.abs(Math.sqrt(dx * dx + dy * dy));
      if (distance < tolerance) {
        console.log('IN PATH');
        controller.clickLink(this);
      }
    }

    c.stroke();


  }

  private linepointNearestMouse(line: {x0: number; y0: number; x1: number; y1: number}, x: number, y: number) {
    var dx = line.x1 - line.x0;
    var dy = line.y1 - line.y0;
    var t = ((x - line.x0) * dx + (y - line.y0) * dy) / (dx * dx + dy * dy);
    var lineX = MathUtils.lerp(line.x0, line.x1, t);
    var lineY = MathUtils.lerp(line.y0, line.y1, t);
    return ({
      x: lineX,
      y: lineY
    });
  };

}
